import { getCurrentDealerContacts, getDealerContacts } from '../../../../services/api/miles/miles-services';
import { assertDefinedVoid } from '../../../../services/common/miscUtils';
import { OptionsItem } from '../../../../services/common/miscUtils.types';

// Extract first and last name from a username separated by spaces or commas.
const getNameParts = (name: string) => {
  const parts = name.trim().split(/,|\s+/).filter(Boolean);

  return {
    firstName: parts[0] ?? '',
    lastName: parts.at(-1) ?? '',
  };
};

export const initializeSalesPersonDropdown = async (
  setSalesPersons: (salesPerson: Array<OptionsItem<string>>) => void
) => {
  const { dealers } = await getCurrentDealerContacts();
  const salesPerson = dealers?.[0]?.salesPerson;
  const milesCompanyId = salesPerson?.milesBrokerCompanies?.[0]?.milesCompanyId;

  assertDefinedVoid(milesCompanyId, 'milesCompanyId is not defined');
  const responseDealerContacts = await getDealerContacts(milesCompanyId);

  const dealerContactsList: Array<OptionsItem<string> | null> =
    responseDealerContacts.dealers
      ?.sort((a, b) => {
        const aName = getNameParts(a.salesPerson.username ?? '');
        const bName = getNameParts(b.salesPerson.username ?? '');

        // Sort by last name first. If last names are equal, sort by first name.
        // If both names are identical, use milesSalesPersonSignOnId as a final tie-breaker.
        return (
          aName.lastName.localeCompare(bName.lastName) ||
          aName.firstName.localeCompare(bName.firstName) ||
          (a.salesPerson.milesSalesPersonSignOnId ?? '').localeCompare(b.salesPerson.milesSalesPersonSignOnId ?? '')
        );
      })
      .map((dealer) => {
        const { username, milesSalesPersonId, milesSalesPersonSignOnId } = dealer.salesPerson;
        if (!username || !milesSalesPersonId) return null;
        return { value: milesSalesPersonId, label: `${milesSalesPersonSignOnId ?? undefined} - ${username}` };
      }) ?? [];

  setSalesPersons(dealerContactsList.filter(Boolean) as OptionsItem<string>[]);
};
